// import React from "react";
// import {
//     FaRegEnvelope,
//     FaGithub,
//     FaLinkedin,
//     FaInstagram,
//     FaTwitter,
//     FaReddit,
//   } from "react-icons/fa"

// const Header = () => {
//   const image = require("../../img/me.jpg");

//   const iconStyle = { color: "white", fontSize: "1.5em", margin: 10 }
//   return (
//     <div className="jumbotron">
//       <div className="jumbotron-text">
//         <img className="center_circle_image" src={image.default} />
//         <h1>Hello!</h1>
//         <h2>I'm Sidhant Puntambekar</h2>
//         <h4>Computer Scientist | Computational Biologist</h4>
//         <a className="social" href="mailto:sidhantnp@yahoo.com">
//                 <FaRegEnvelope style={iconStyle} />   
//         </a>
//         <a
//               className="social"
//               href="https://github.com/SidhantPuntambekar"
//               target="_blank"
//               rel="noreferrer"
//             >
//                 <FaGithub style={iconStyle}/>
//         </a>
//         <a
//               className="social"
//               href="https://www.linkedin.com/in/sidhant-puntambekar/"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <FaLinkedin style={iconStyle}/>
//             </a>
//         <a
//             className="social"
//             href="https://www.instagram.com/sidhantnp"
//             target="_blank"
//             rel="noreferrer"
//         >
//             <FaInstagram style={iconStyle}/>
//         </a>
//         <a
//             className="social"
//             href="https://twitter.com/sidhantnp"
//             target="_blank"
//             rel="noreferrer"
//         >
//             <FaTwitter style={iconStyle}/>
//         </a>
//         <a
//             className="social"
//             href="https://www.reddit.com/user/XLongshotz68"
//             target="_blank"
//             rel="noreferrer"
//         >
//             <FaReddit style={iconStyle}/>
//         </a>
//       </div>
//     </div>
//   );
// };

// export default Header;

import React from "react";
import {
  FaRegEnvelope,
  FaGithub,
  FaLinkedinIn,
  FaOrcid,
  FaInstagram,
  FaTwitter,
  FaReddit,
} from "react-icons/fa";
import { SiGooglescholar } from "react-icons/si";

const Header = () => {
  const image = require("../../img/me.jpg");

  const iconStyle = { color: "white", fontSize: "1.8em", margin: "0 12px" };

  const imageStyle = {
    width: "clamp(180px, 40vw, 320px)",
    height: "clamp(180px, 40vw, 320px)",
    objectFit: "cover",
    objectPosition: "center top",
    borderRadius: "50%",
  };

  return (
    <div className="jumbotron">
      <div className="jumbotron-text">
        <img className="center_circle_image" style={imageStyle} src={image.default} alt="Sidhant" />
        <h1>Hello!</h1>
        <h2>I'm Sidhant Puntambekar</h2>
        <h4>Computer Scientist | Computational Biologist</h4>

        <div className="social-icons">
          <a className="social" href="mailto:sidhantnp@yahoo.com">
            <FaRegEnvelope style={iconStyle} />
          </a>
          <a className="social" href="https://github.com/SidhantPuntambekar" target="_blank" rel="noreferrer">
            <FaGithub style={iconStyle} />
          </a>
          <a className="social" href="https://www.linkedin.com/in/sidhant-puntambekar/" target="_blank" rel="noreferrer">
            <FaLinkedinIn style={iconStyle} />
          </a>
          <a className="social" href="https://scholar.google.com/citations?user=f7bcIYUAAAAJ&hl=en" target="_blank" rel="noreferrer">
            <SiGooglescholar style={iconStyle} />
          </a>
          <a className="social" href="https://orcid.org/0009-0004-2111-3087" target="_blank" rel="noreferrer">
            <FaOrcid style={iconStyle} />
          </a>
          <a className="social" href="https://www.instagram.com/sidhantnp" target="_blank" rel="noreferrer">
            <FaInstagram style={iconStyle} />
          </a>
          <a className="social" href="https://twitter.com/sidhantnp" target="_blank" rel="noreferrer">
            <FaTwitter style={iconStyle} />
          </a>
          <a className="social" href="https://www.reddit.com/user/XLongshotz68" target="_blank" rel="noreferrer">
            <FaReddit style={iconStyle} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;